import CheckboxWithInputGroupField from './CheckboxWithInputGroupField.component';

export default CheckboxWithInputGroupField;